(function () {
  var STEP = 10;
  var MIN = 10;

  function toInt(v, fallback) {
    var n = parseInt(v, 10);
    return isNaN(n) ? fallback : n;
  }

  function roundToStep(value, step, min) {
    if (value < min) return min;
    return Math.round(value / step) * step;
  }

  function roundUpToStep(value, step, min) {
    if (value < min) return min;
    return Math.ceil(value / step) * step;
  }

  function getRules(input) {
    var step = toInt(input.getAttribute("step"), STEP);
    var min = toInt(input.getAttribute("min"), MIN);
    if (step < 1) step = STEP;
    if (min < 0) min = MIN;
    return { step: step, min: min };
  }

  function setValue(input, value) {
    input.value = String(value);
    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  // + / - click
  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".quantity__button");
    if (!btn) return;

    var wrap = btn.closest("quantity-selector, .quantity");
    if (!wrap) return;

    var input = wrap.querySelector('input.quantity__input[type="number"]');
    if (!input) return;

    var rules = getRules(input);
    var val = toInt(input.value, rules.min);

    if (btn.name === "plus") val += rules.step;
    if (btn.name === "minus") val -= rules.step;

    if (val < rules.min) val = rules.min;

    // pidetään aina tasalukuina stepin mukaan
    val = roundToStep(val, rules.step, rules.min);

    setValue(input, val);
  });

  // korjaa käsin kirjoitettu arvo blurissa
  document.addEventListener(
    "blur",
    function (e) {
      var input = e.target;
      if (!input || input.type !== "number") return;

      var name = input.getAttribute("name") || "";
      if (name !== "quantity" && name !== "updates[]") return;

      var rules = getRules(input);
      var val = toInt(input.value, rules.min);

      // pyöristetään ylöspäin seuraavaan 10:een
      val = roundUpToStep(val, rules.step, rules.min);

      setValue(input, val);
    },
    true
  );

  // varmistus submitissä
  document.addEventListener(
    "submit",
    function (e) {
      var form = e.target;
      if (!form || !form.querySelectorAll) return;

      form
        .querySelectorAll('input[type="number"][name="quantity"], input[type="number"][name="updates[]"]')
        .forEach(function (input) {
          var rules = getRules(input);
          var val = toInt(input.value, rules.min);
          val = roundUpToStep(val, rules.step, rules.min);
          setValue(input, val);
        });
    },
    true
  );
})();
